import { merge } from 'lodash';


const baseUrl = '/api/v2';

/**
 * @function api
 * @description Wrapper for API requests
 *
 * @param {String} url route to resource
 * @param {Object} options http options
 *
 * @returns Promise
 */
const api = function(url, options={}) {
  if (!url) return new Error('No url provided');

  // Bootstrap a generic promise to return
  let resolve, reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });

  // Do our fetch
  fetch(baseUrl + url, Object.assign({}, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }
  }, options))
    .then(res => {
      // If API returned 408, redirect to login page
      if (res.status == 401 && window.location.pathname != '/login') {
        history.pushState({}, undefined, `/login?return_to${location.pathname}`);
        reject(res);
        return;
      }
      if (!res.ok) {
        reject(res);
        return;
      }
      // On success, resolve our promise
      resolve(res);
    })
    // Otherwise, reject the promise
    .catch(reject);

  return promise;
}

const parseErrors = function(res) {
  if (typeof res == 'string') {
    return res;
  }

  if (res.errors) {
    const errorObj = {};
    if (res.errors.$) {
      try {
        const errors = res.errors.$[0].split('including the following: ')[1].split(', ');
        errors.forEach(e => errorObj[e] = res.errors.request[0] || true);
        return errorObj;
      } catch (e) {/* no-op*/}
    }
    const keys = Object.keys(res.errors);
    if (keys?.length) {
      keys.forEach(key => errorObj[key] = res.errors[key][0] || true);
      return errorObj;
    }
  }

  return 'An unknown error occurred';
}

async function downloadFile(url, filename) {
  try {
    const response = await api(url);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename || 'download';
    link.style.display = 'none';
    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    throw error;
  }
}

export { downloadFile, parseErrors };

export default api;
